import { Box } from '@material-ui/core'
import Card, { CardProps } from '@material-ui/core/Card'
import { makeStyles } from '@material-ui/core/styles'
import React from 'react'

import { dropShadowFromElevation } from '../../lib/theming/shadows'
import { Theme } from '../../lib/theming/Theme'
import HolePunch, { HolePunchProps } from './HolePunch'

const useStyles = makeStyles<Theme, { cardBgColor?: string; elevation: number }>({
  cardRoot: props => ({
    backgroundColor: props.cardBgColor,
  }),
  dropShadow: ({ elevation }) => ({
    filter: dropShadowFromElevation(elevation),
  }),
})

export type HolePunchedCardProps = HolePunchProps & CardProps & { cardBgColor?: string }

const HolePunchedCard = ({
  radius,
  position,
  offset,
  height,
  children,
  elevation = 1,
  cardBgColor,
  ...cardProps
}: HolePunchedCardProps) => {
  const { dropShadow, cardRoot } = useStyles({ cardBgColor, elevation })
  return (
    <Box className={dropShadow} flex="1 1 0" height={height}>
      <HolePunch height={height} offset={offset} position={position} radius={radius}>
        <Card classes={{ root: cardRoot }} elevation={0} {...cardProps}>
          {children}
        </Card>
      </HolePunch>
    </Box>
  )
}

export default HolePunchedCard
